import { Country, SupportedLocale } from '@afterpay/types'
import { useFlag as useFeatureFlag } from '@afterpaytouch/feature'

export const LaunchDarklyFlags = {
  AchEligibilityEnabled: 'ach-eligibility-enabled',
  AuPayIn4UpdatedTerms: 'rocketship.au-pay-in-4-updated-terms',
  BillingAddressDetails: 'billing-address-details',
  BillingAgreementAchPaymentMethodEnabled: 'billing-agreement-ach-payment-method-enabled',
  CardScanningNewConsumerPortalAddPaymentEnabled: 'card-scanning-new-consumer-portal-add-payment-enabled',
  CardScanningNewConsumerPortalCustomPaymentEnabled: 'card-scanning-new-consumer-portal-custom-payment-enabled',
  ChangePaymentDateForConsumerLendingEnabled: 'change-payment-date-for-consumer-lending-enabled',
  ConsumerPortalAvailableToSpendDisabled: 'consumer-portal-available-to-spend-disabled',
  ConsumerPortalHardshipAccountPaymentsEnabled: 'consumer-portal-hardship-account-payments-enabled',
  ConsumerPortalHeaderLendingEnabled: 'consumer-portal-header-lending-enabled',
  ConsumerPortalHelpButtonEnabled: 'consumer-portal-help-button-enabled',
  ConsumerPortalIsApplePayDisabled: 'consumer-portal-is-apple-pay-disabled',
  ConsumerPortalIdentityVerificationDisabled: 'consumer-portal-identity-verification-disabled',
  ConsumerPortalModalLendingEnabled: 'consumer-portal-modal-lending-enabled',
  ConsumerPortalMonthlyPaymentsLendingEnabled: 'consumer-portal-monthly-payments-lending-enabled',
  ConsumerPortalPayMonthlyEnabled: 'consumer-portal-pay-monthly-enabled',
  ConsumerPortalOrderDetailV2Enabled: 'consumer-portal-order-detail-v2-enabled',
  ConsumerPortalOrderEnableDisputeEnabled: 'consumer-portal-order-enable-dispute',
  ConsumerPortalPersonalizedAdsEnabled: 'consumer-portal-personalized-ads-enabled',
  ConsumerPortalPpaLinkDisplay: 'consumer-portal-ppa-link-display',
  ConsumerPortalPrescreenedOffersOptOutEnabled: 'consumer-portal-prescreened-offers-opt-out-enabled',
  ConsumerPortalPulseEnabled: 'consumer-portal-pulse-enabled',
  ConsumerPortalStorePanelEnabled: 'consumer-portal-store-panel-enabled',
  ConsumerPortalThreeDSEnabled: 'consumer-portal-three-ds-enabled',
  ConsumerPortalPreferencesDisabled: 'consumer-portal-preferences-disabled',
  ConsumerPortalWelcomeModalEnabled: 'consumer-portal-welcome-modal-enabled',
  ConsumerPortalAutocompleteInputAddressEnabled: 'consumer-portal-autocomplete-input-address-on-edit-profile-enabled',
  ConsumerPortalGetHelpRedirectFritesUsers: 'consumer-portal-get-help-redirect-frites-users',
  ConsumerPortalHideCardHolderName: 'consumer-portal-hide-card-holder-name',
  EnableUkCardholderNameControls: 'enable-uk-cardholder-name-controls',
  ConsumerPortalOrderPageFilterChipsEnabled: 'consumer-portal-order-page-filter-chips-enabled',
  ConsumerPortalRevokeConsentEnabled: 'consumer-portal-revoke-consent-enabled',
  ConsumerPortalArcadeTheme: 'rocketship.consumer-portal-arcade-theme',
  DisableChangePaymentDateButton: 'disable-change-payment-date-button',
  IrChargebackInfoEnabled: 'ir-chargeback-info-enabled',
  IrDisputeCreateButtonEnabledNew: 'ir-dispute-create-button-enabled-new',
  IrDisputeCreationMerchantContactInfoEnabled: 'ir-dispute-creation-merchant-contact-info-enabled', // archived flag
  IrDisputeTrackingConsumerPortalEnabled: 'ir-dispute-tracking-consumer-portal-enabled',
  IrReportLostAndStolenCardNewConsumerButtonEnabled: 'ir-report-lost-and-stolen-card-new-consumer-button-enabled',
  IrDisputePermissionControlEnabled: 'ir-dispute-permission-control-enabled',
  IrOrderMismatchFlowEnabled: 'ir-order-mismatch-flow-enabled',
  IrPushBackDisputeConsumerEnabled: 'ir-push-back-dispute-consumer-enabled',
  MaintenanceMode: 'maintenance-mode',
  MaintenanceModeText: 'maintenance-mode-text',
  SingleUsePaymentFinalizedOrderDelay: 'single-use-payment-finalized-order-delay',
  CloseOrReactivateAccountFlow: 'close-or-reactivate-account-flow-enabled',
  PayInThreeEnabled: 'pay-in-three-enabled',
  PortalAlignPayday: 'portal-align-payday-enabled',
  PpaDocsEndpointDrivenEnabled: 'paylater.enable-ppa-docs-endpoint-driven',
  EnableRemoveCashAppPay: 'enable-remove-cash-app-pay',
  GravatarEnabled: 'gravatar-enabled',
  ConsumerPortalPayMonthlyDecreaseLimit: 'consumer-portal-pay-monthly-decrease-limit-enabled',
  ConsumerPortalPayMonthlyClose: 'consumer-portal-pay-monthly-close-credit-facility-enabled',
  ConsumerPortalTerminationNoticeModalCountryList: 'consumer-portal-termination-notice-modal-country-list',
  IsAmexSoftCloseEnabled: 'amex-soft-close-enabled',
  AutopayToggleEnabled: 'paylater.autopay-toggle-enabled',
  EnableMpanApplePayFlow: 'rocketship.enable-mpan-apple-pay-flow',
  BlockChaseCCEnabled: 'rocketship.block-chase-cc-enabled',
  LoginMigration: 'consumer-portal-login-migration-variant',
  REGISTRATION_STATE_VALIDATION: 'rocketship.enable-registration-state-validation',
  UK_MRKT_REGS_FCA: 'uk-mrkt-regs-fca',
  UK_CREDIT_CHECK_ENABLED: 'rocketship.gb-credit-check-enabled',
  ConsumerPortalAFFEnabled: 'consumer-portal-aff-enabled',
  Section75Enabled: 'paylater.s75-disputes-enabled',
  EnabledPortalSignup: 'rocketship.enabled-portal-signup',
  SoftIdRetryEnabled: 'rocketship.soft-id-retry-enabled',
  HardshipEnabled: 'rocketship.portal-hardship-enabled',
  VERIFY_SMS_DELAY: 'rocketship.verify-service.sms-delay', // permanently flag disabled it in local and qa environments
  CAIdvQuebecEnabled: 'rocketship.CA-idv-quebec-enabled',
  ConsumerProtectedDisputeEnabled: 'rocketship.consumer-protected-dispute-enabled',
  CompleteAuUnsuitabilityOnHomepage: 'rocketship.complete-au-unsuitability-questions-on-portal-homepage',
  EnableUkRegsServicing: 'rocketship.enable-uk-regs-servicing',
  EnableUkRegsAffordabilityForm: 'rocketship.portal-enable-uk-regs-affordability-form',
  ManualIdvEnabled: 'rocketship.manual-idv-enabled',
  PortalRtkQueryMigration: 'rocketship.portal-rtk-query-migration',
  EnablePortalCashWebLogin: 'rocketship.enable-portal-cash-web-login',
  ConsumerPortalCashCohortPaymentMethodsDisabled: 'consumer-portal-cash-cohort-payment-methods-disabled',
} as const
export type LaunchDarklyFlag = (typeof LaunchDarklyFlags)[keyof typeof LaunchDarklyFlags]

export interface LaunchDarklyFlagsValues {
  [LaunchDarklyFlags.AchEligibilityEnabled]: boolean
  [LaunchDarklyFlags.AuPayIn4UpdatedTerms]: boolean
  [LaunchDarklyFlags.BillingAddressDetails]: boolean
  [LaunchDarklyFlags.BillingAgreementAchPaymentMethodEnabled]: boolean
  [LaunchDarklyFlags.CardScanningNewConsumerPortalAddPaymentEnabled]: boolean
  [LaunchDarklyFlags.CardScanningNewConsumerPortalCustomPaymentEnabled]: boolean
  [LaunchDarklyFlags.ChangePaymentDateForConsumerLendingEnabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalAvailableToSpendDisabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalHardshipAccountPaymentsEnabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalHeaderLendingEnabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalHelpButtonEnabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalIsApplePayDisabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalIdentityVerificationDisabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalModalLendingEnabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalMonthlyPaymentsLendingEnabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalPayMonthlyEnabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalOrderDetailV2Enabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalPersonalizedAdsEnabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalOrderEnableDisputeEnabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalPpaLinkDisplay]: boolean
  [LaunchDarklyFlags.ConsumerPortalPrescreenedOffersOptOutEnabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalPulseEnabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalStorePanelEnabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalThreeDSEnabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalPreferencesDisabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalWelcomeModalEnabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalAutocompleteInputAddressEnabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalGetHelpRedirectFritesUsers]: boolean
  [LaunchDarklyFlags.ConsumerPortalHideCardHolderName]: boolean
  [LaunchDarklyFlags.EnableUkCardholderNameControls]: boolean
  [LaunchDarklyFlags.ConsumerPortalOrderPageFilterChipsEnabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalRevokeConsentEnabled]: boolean
  [LaunchDarklyFlags.DisableChangePaymentDateButton]: boolean
  [LaunchDarklyFlags.IrDisputeCreateButtonEnabledNew]: boolean
  [LaunchDarklyFlags.IrDisputeTrackingConsumerPortalEnabled]: boolean
  [LaunchDarklyFlags.IrReportLostAndStolenCardNewConsumerButtonEnabled]: boolean
  [LaunchDarklyFlags.IrDisputePermissionControlEnabled]: boolean
  [LaunchDarklyFlags.IrChargebackInfoEnabled]: boolean
  [LaunchDarklyFlags.IrOrderMismatchFlowEnabled]: boolean
  [LaunchDarklyFlags.IrPushBackDisputeConsumerEnabled]: boolean
  [LaunchDarklyFlags.MaintenanceModeText]: string
  [LaunchDarklyFlags.MaintenanceMode]: boolean
  [LaunchDarklyFlags.CloseOrReactivateAccountFlow]: boolean
  [LaunchDarklyFlags.SingleUsePaymentFinalizedOrderDelay]: {
    merchants: Array<{
      id: number
      pendingDuration: number
    }>
  }
  [LaunchDarklyFlags.PayInThreeEnabled]: boolean
  [LaunchDarklyFlags.PortalAlignPayday]: boolean
  [LaunchDarklyFlags.PpaDocsEndpointDrivenEnabled]: boolean
  [LaunchDarklyFlags.GravatarEnabled]: boolean
  [LaunchDarklyFlags.ConsumerPortalPayMonthlyDecreaseLimit]: boolean
  [LaunchDarklyFlags.ConsumerPortalPayMonthlyClose]: boolean
  [LaunchDarklyFlags.ConsumerPortalTerminationNoticeModalCountryList]: {
    countries: Country[]
    locales: SupportedLocale[]
  }
  [LaunchDarklyFlags.IsAmexSoftCloseEnabled]: boolean
  [LaunchDarklyFlags.AutopayToggleEnabled]: boolean
  [LaunchDarklyFlags.EnableMpanApplePayFlow]: boolean
  [LaunchDarklyFlags.BlockChaseCCEnabled]: boolean
  [LaunchDarklyFlags.LoginMigration]: string
  [LaunchDarklyFlags.REGISTRATION_STATE_VALIDATION]: boolean
  [LaunchDarklyFlags.UK_MRKT_REGS_FCA]: boolean
  [LaunchDarklyFlags.ConsumerPortalAFFEnabled]: boolean
  [LaunchDarklyFlags.Section75Enabled]: boolean
  [LaunchDarklyFlags.EnabledPortalSignup]: boolean
  [LaunchDarklyFlags.SoftIdRetryEnabled]: boolean
  [LaunchDarklyFlags.HardshipEnabled]: boolean
  [LaunchDarklyFlags.VERIFY_SMS_DELAY]: boolean
  [LaunchDarklyFlags.CAIdvQuebecEnabled]: boolean
  [LaunchDarklyFlags.ConsumerProtectedDisputeEnabled]: boolean
  [LaunchDarklyFlags.CompleteAuUnsuitabilityOnHomepage]: boolean
  [LaunchDarklyFlags.EnableUkRegsServicing]: boolean
  [LaunchDarklyFlags.EnableUkRegsAffordabilityForm]: boolean
  [LaunchDarklyFlags.ManualIdvEnabled]: boolean
  [LaunchDarklyFlags.PortalRtkQueryMigration]: boolean
  [LaunchDarklyFlags.EnablePortalCashWebLogin]: boolean
  [LaunchDarklyFlags.ConsumerPortalCashCohortPaymentMethodsDisabled]: boolean
}

export function useFlag(flag: LaunchDarklyFlag): boolean
export function useFlag<LaunchDarklyFlag extends keyof LaunchDarklyFlagsValues>(
  flag: LaunchDarklyFlag,
  defaultValue: LaunchDarklyFlagsValues[LaunchDarklyFlag]
): LaunchDarklyFlagsValues[LaunchDarklyFlag]
export function useFlag<LaunchDarklyFlag extends keyof LaunchDarklyFlagsValues>(
  flag: LaunchDarklyFlag,
  defaultValue?: LaunchDarklyFlagsValues[LaunchDarklyFlag]
): LaunchDarklyFlagsValues[LaunchDarklyFlag] | boolean {
  return useFeatureFlag(flag, defaultValue) ?? false
}
